import { render, staticRenderFns } from "./directSectionFaq.vue?vue&type=template&id=f6bfb0ac&scoped=true"
import script from "./directSectionFaq.vue?vue&type=script&lang=js"
export * from "./directSectionFaq.vue?vue&type=script&lang=js"
import style0 from "./directSectionFaq.vue?vue&type=style&index=0&id=f6bfb0ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6bfb0ac",
  null
  
)

export default component.exports